module.exports = __webpack_public_path__ + "img/ic-manage-account_bw.2a02c732.svg";